import { AnalyticsEventTypes } from 'services/analytics/eventNames';

export const getLastEvent = (eventName?: AnalyticsEventTypes) => {
  const dataLayer = window.dataLayer || [];
  const events = [...dataLayer].reverse();
  const lastEvent = eventName
    ? events.find((event) => event.event === eventName)
    : events[0];

  return lastEvent;
};
